import en from "./en.js";
import es from "./es.js";
import pt from "./pt.js";
const LOCALES = {
    es: es,
    pt: pt,
    en: en
};
const i18n = LOCALES;
export default i18n;
export { LOCALES };
